import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import { signOut, signInAnonymously } from 'firebase/auth';
import { auth } from '../firebase-config';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import { useOutletContext } from 'react-router-dom';
import '../components/SideMenu.css';

function Home() {
  const [nickname, setNickname] = useState('?');
  const [userName, setUserName] = useState('');
  
  const { currentUser } = useAuth();
  const isAuthenticated = !!currentUser;
  
  const [isReady, setIsReady] = useState(false);
  const [isGuestLogin, setIsGuestLogin] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);

  // --- [수정 1] 팝업 단계 및 입력 정보 State 추가 ---
  const [popupStep, setPopupStep] = useState('terms'); // 'terms' (약관) 또는 'info' (정보입력)
  const [birthDate, setBirthDate] = useState(''); // YYMMDD
  const [gender, setGender] = useState('');       // 'M' | 'F'
  
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [agreedToPrivacy, setAgreedToPrivacy] = useState(false);
  const [agreedToAge, setAgreedToAge] = useState(false);
  const [agreedToOverseas, setAgreedToOverseas] = useState(false);

  const { toggleMenu, togglePopup } = useOutletContext();

  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem('profileCarouselIndex');
    const fetchUserProfile = async () => {
      if (currentUser) {
        try {
          const idToken = await currentUser.getIdToken();
          const response = await fetch(`${API_URL}/api/login/me`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` }
          });
          const data = await response.json();

          if (response.ok && data.isAuthenticated) {
            if (data.isNewUser) {
              setIsReady(false);
              setAgreedToTerms(false);
              setAgreedToPrivacy(false);
              setAgreedToAge(false);
              setShowConsentPopup(true);
            } else {
              setNickname(data.user.nickname);
              setUserName(data.user.userName);
              localStorage.setItem('userNickname', data.user.nickname);
              localStorage.setItem('userCharacter', data.user.character);
              localStorage.setItem('currentUserId', data.user.id);
              setIsReady(true);
            }
          } else {
            if (response.status === 403) {
                alert(data.message);
            }
             await signOut(auth);
          }
        } catch (error) {
          console.error("사용자 프로필 조회 실패:", error);
          await signOut(auth);
        }
      } else {
        setNickname('?');
        setUserName('');
        localStorage.clear();
        setIsReady(false);
        setShowConsentPopup(false);
      }
    };

    fetchUserProfile();
  }, [currentUser]);

  // --- [수정 2] 약관 동의 후 '다음' 버튼 클릭 핸들러 ---
  const handleTermsNext = () => {
    if (agreedToTerms && agreedToPrivacy && agreedToAge && agreedToOverseas) {
      setPopupStep('info'); // 정보 입력 단계로 이동
    }
  };

  const handleGuestStartClick = async () => {
    try{
      await signInAnonymously(auth);
    } catch (error) {
      alert("오류가 발생했습니다.");
    }
  }

  const handleChatClick = () => {
    navigate('/matching');
    // setIsMenuOpen(false);
  };

  const handleFinalSubmit = async () => {
    // [수정] 유효성 검사 (기존 로직 유지)
    if (!allRequiredAgreed) return;

    if (birthDate.length !== 8 || isNaN(birthDate)) {
      alert("생년월일 8자리를 정확히 입력해주세요. (예: 990101)");
      return;
    }
    if (!gender) {
      alert("성별을 선택해주세요.");
      return;
    }

    try {
      let idToken;

      // ============================================================
      // [추가된 로직] 비회원 모드라면? 여기서 로그인을 먼저 진행한다!
      // ============================================================
      if (isGuestLogin) {
        // 1. Firebase 익명 로그인 수행
        const result = await signInAnonymously(auth);
        const user = result.user;
        
        // 2. 방금 로그인한 유저의 토큰을 가져옴
        idToken = await user.getIdToken();
      
      } else {
        // [기존 로직] 구글 로그인 유저는 이미 currentUser가 있음
        if (!currentUser) return;
        idToken = await currentUser.getIdToken();
      }

      // 3. (공통) 백엔드에 "약관 동의했으니 유저 정보 만들어줘" 요청
      const response = await fetch(`${API_URL}/api/login/consent`, {
          method: 'POST',
          headers: { 
            'Authorization': `Bearer ${idToken}`, 
            'Content-Type': 'application/json' 
          },
          body: JSON.stringify({
            birthDate: birthDate,
            gender: gender
          })
      });

      const data = await response.json();
      
      if (response.ok) {
          // 성공 처리 (기존과 동일)
          setShowConsentPopup(false);
          setNickname(data.user.nickname);
          setUserName(data.user.userName);
          localStorage.setItem('userNickname', data.user.nickname);
          localStorage.setItem('userCharacter', data.user.character);
          localStorage.setItem('currentUserId', data.user.id);
          setIsReady(true);
          
          // 비회원 플래그 초기화
          setIsGuestLogin(false);
          setPopupStep('terms');
          setBirthDate('');
          setGender('');

      } else {
          throw new Error(data.message);
      }

    } catch (error) {
        console.error("가입 처리 중 오류:", error);
        alert("오류가 발생했습니다. 다시 시도해주세요.");
        // 실패 시 로그아웃 처리해서 깔끔하게 리셋
        await signOut(auth);
        setIsGuestLogin(false); 
    }
  };

  const handleCancelConsent = async () => {
      alert("서비스를 이용하시려면 약관 동의 및 정보 입력이 필요합니다.");
      
      // [추가] 팝업 닫고, 비회원 플래그도 끄기
      setShowConsentPopup(false);
      setIsGuestLogin(false);

      // 만약 구글 로그인 상태였다면 로그아웃 (기존 로직)
      if (currentUser) {
        await signOut(auth);
      }
  };

  // [추가] '모두 동의하기' 체크박스 핸들러
  const handleCheckAll = (e) => {
    const isChecked = e.target.checked;
    setAgreedToTerms(isChecked);
    setAgreedToPrivacy(isChecked);
    setAgreedToAge(isChecked);
    setAgreedToOverseas(isChecked);
  };

  const ChromeBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
      const userAgent = navigator.userAgent;
      
      // 감지 로직: Chrome이 아니고(false), 카카오톡 인앱 브라우저도 아닐 때(false)
      // (카카오톡은 이미 다른 코드로 막고 있으니까요)
      const isChrome = /Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor);
      const isKakao = /KAKAOTALK/i.test(userAgent);

      // "크롬이 아니면서 & 카카오톡도 아닐 때" 배너 노출
      if (!isChrome && !isKakao) {
        setVisible(true);
      }
    }, []);

    if (!visible) return null;

    return (
      <div className="chrome-recommend-banner">
        <div className="cr-text">
          <span>⚡ <strong>Chrome</strong> 브라우저에 최적화된 서비스입니다.</span>
        </div>
        <button className="cr-close" onClick={() => setVisible(false)}>×</button>
      </div>
    );
  };

  // 모든 필수 항목이 체크되었는지 확인하는 변수
  const allRequiredAgreed = agreedToTerms && agreedToPrivacy && agreedToAge && agreedToOverseas;

  return (
    <div className="home-container">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>

      <div className="top-bar">
        <button className="menu-button" onClick={toggleMenu}>≡</button>
      </div>
      
      <div className="main-content">
        <div className="title-container">
          <h1 className="main-title">TAIM TALK</h1>
          <p className="subtitle">인공지능이 발견하는 당신의 새로운 모습</p>
        </div>

        <div className="description">
            {isReady ? (
            <>
                <p className="welcome-message">
                <span className="user-name">{userName}</span>님, 별들 사이에서 당신을 기다렸어요.
                </p>
                <p>대화 속에서 AI가 찾아낼 당신의 진짜 모습은 무엇일까요?</p>
                <p>지금 바로, 미지의 상대와 대화를 나누고 나만의 프로필을 만들어보세요.</p>
                <p className="nickname-display">현재 닉네임: {nickname}</p>
            </>
            ) : !isAuthenticated ? (
            <>
                <p>밤하늘의 별처럼 수많은 가능성 속에서,</p>
                <p>아직 발견되지 않은 당신의 이야기를 찾아보세요.</p>
                <p>AI와 함께 떠나는 자아 발견의 여정을 시작해보세요.</p>
            </>
            ) : (
            <p>로그인 중입니다. 잠시만 기다려주세요.</p>
            )}
            <p className="brand-phrase">Third-party AI Introduces Me.</p>
        </div>
      </div>


      <div className="action-area">
        {isReady ? (
          <button className="chat-button" onClick={handleChatClick}>
            실시간 채팅
          </button>
        ) : !isAuthenticated ? (
          <div className="guest-wrapper">
            <button className="guest-start-button" onClick={togglePopup}>
              간편 로그인으로 시작하기
            </button>

            <div className="guest-warning-box">
              <p>비회원 상태에서는 브라우저/기기 변경 시</p>
              <p><span className="warning-highlight">대화 내용이 사라집니다.</span></p>
            </div>
            
            <button className="login-link-button" onClick={handleGuestStartClick}>
              비회원으로 시작하기
            </button>
            <ChromeBanner/>
          </div>
        ) : null}
      </div>

      {showConsentPopup && (
        <div className="popup-overlay">
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            {popupStep === 'terms' ? (
              <>
              <h3>서비스 이용 동의</h3>
              <p>서비스를 이용하시려면 아래 약관에 동의해주세요.</p>
              {/* [추가] 모두 동의하기 체크박스 */}
              <div className="consent-item all-agree">
                <input 
                  type="checkbox"
                  id="all-agree"
                  // 모든 개별 항목이 체크되어야 '모두 동의'도 체크됨
                  checked={allRequiredAgreed}
                  onChange={handleCheckAll}
                />
                <label htmlFor="all-agree">
                  <strong>전체 동의</strong>
                </label>
              </div>
              <div className="consent-item">
                <input 
                  type="checkbox" 
                  id="age"
                  checked={agreedToAge}
                  onChange={(e) => setAgreedToAge(e.target.checked)}
                />
                <label htmlFor="age">
                  (필수) 본인은 만 14세 이상입니다.
                </label>
              </div>
              <div className="consent-item">
                <input 
                  type="checkbox" 
                  id="terms"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                />
                <label htmlFor="terms">
                  (필수) <a href="/terms" target="_blank" rel="noopener noreferrer">서비스 이용약관</a>에 동의합니다.
                </label>
              </div>
              <div className="consent-item">
                <input 
                  type="checkbox" 
                  id="privacy"
                  checked={agreedToPrivacy}
                  onChange={(e) => setAgreedToPrivacy(e.target.checked)}
                />
                <label htmlFor="privacy">
                  (필수) <a href="/policy" target="_blank" rel="noopener noreferrer">개인정보 수집 및 이용</a>에 동의합니다.
                </label>
              </div>
              <div className="consent-item">
                <input 
                  type="checkbox" 
                  id="overseas"
                  checked={agreedToOverseas}
                  onChange={(e) => setAgreedToOverseas(e.target.checked)}
                />
                <label htmlFor="overseas">
                  (필수) <a href="/policy#제6조-개인정보의-국외-이전에-관한-사항" target="_blank" rel="noopener noreferrer">개인정보 국외 이전</a>에 동의합니다.
                </label>
              </div>
              <div className='consent-buttons'>
                <button 
                  onClick={handleTermsNext}
                  disabled={!allRequiredAgreed}
                >
                  동의하고 시작하기
                </button>
                <button className='cancel-button' onClick={handleCancelConsent}>취소</button>
              </div>
              </>
            ) : (
              <>
                <h3>기본 정보 입력</h3>
                <p>정확한 정보를 입력해주세요.</p>
                
                <div className="info-input-container">
                  <div className="input-group">
                    <label>생년월일</label>
                    <input 
                      type="text" 
                      placeholder="YYYYMMDD (예: 19990101)" 
                      maxLength={8}
                      value={birthDate}
                      onChange={(e) => setBirthDate(e.target.value.replace(/[^0-9]/g, ''))}
                      className="birth-input"
                    />
                  </div>
                  
                  <div className="input-group">
                    <label>성별</label>
                    <div className="gender-buttons">
                      <button 
                        className={`gender-btn ${gender === 'M' ? 'selected' : ''}`}
                        onClick={() => setGender('M')}
                      >
                        남성
                      </button>
                      <button 
                        className={`gender-btn ${gender === 'F' ? 'selected' : ''}`}
                        onClick={() => setGender('F')}
                      >
                        여성
                      </button>
                    </div>
                  </div>
                </div>

                <div className='consent-buttons'>
                  <button onClick={handleFinalSubmit}>
                    시작하기
                  </button>
                  <button className='cancel-button' onClick={() => setPopupStep('terms')}>
                    이전
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;